export default class {
  constructor(number, raceId) {
    this.id = Math.random();
    this.number = number;
    this.raceId = raceId;
    this.free = false;
    this.selected = false;
    this.secondSide = false;
    this.empty = false;
  }

  get isFree() {
    return this.free;
  }

  set isFree(value) {
    this.free = value;
  }

  get isSelected() {
    return this.selected;
  }

  set isSelected(value) {
    this.selected = value;
  }

  get isSecondSide() {
    return this.secondSide;
  }

  set isSecondSide(value) {
    this.secondSide = value;
  }

  get isEmpty() {
    return this.empty;
  }

  set isEmpty(value) {
    this.empty = value;
  }
}



// WEBPACK FOOTER //
// ./src/components/Passenger/Seat.js